import React from "react";
import { useTranslation } from 'react-i18next';
import { CookieTypeEnum } from '../common/enums'
import Alert from "./Alert";
import { utils } from '../common/utils';

export default function (props) {
    const { t } = useTranslation();

    const { product, showCookieConsent } = props;

    const marketingConsent = showCookieConsent === false || props.isCatalogueMode === true || (showCookieConsent === true && window.CookieConsentApi && (window.CookieConsentApi.allowedCategory(CookieTypeEnum.Marketing) === true));

    if (!product || !product.desktopVideo) return <div />;
    var videoId = utils.getYoutubeId(product.desktopVideo);
    if (videoId === 0) return <div />;

    //const marketingConsent = true;
    //// if (!product || !product.desktopVideo) return <div />;
    //var videoId = 'sRrqF8eXs38'; // utils.getYoutubeId(product.desktopVideo);
    //if (videoId === 0) return <div />;



    return (
        <div className="row padding-top-3x mb-3">
            <div className="col-lg-10 offset-lg-1">
                <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#description"
                            data-toggle="tab"
                            role="tab"
                        >
                            {t("Description")}
                        </a>
                    </li>
                </ul>
                <div className="tab-content">
                    <div
                        className="tab-pane fade show active"
                        id="description"
                        role="tabpanel"
                    >
                        <p className="mb-30">{product.description}</p>
                        {marketingConsent === true && <div className="embed-responsive embed-responsive-16by9">
                            <iframe
                                key={videoId}
                                title="Youtube"
                                className="embed-responsive-item"
                                referrerpolicy="strict-origin-when-cross-origin"
                                src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
                                allowFullScreen
                            />
                        </div>}
                        {marketingConsent === false
                            && <Alert type="info" title={t("ProductVideo")} msg={t("ProductVideoDesc")}>
                                <a type="button" aria-label="{t('Cookie Settings')}" className="view-cookie-setting" data-cc="c-settings" aria-haspopup="dialog" onClick={() => window.CookieConsentApi.showSettings()}>{t('Cookie Settings')}</a>
                            </Alert>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
